// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_Z0Blp","pic":"pic_rAL7C","g-image":"g-image","bottom":"bottom_42qxC","top":"top_1rrtq"};